import React from 'react';
import EmployeeNotice from './EmployeeNotice';

/**
 * /layoff/notice/:hash inside the app, for notices that don't lock the app
 * (waiting for the superintendent, or already signed)
 */
const NoticePage = ({ match, history }) => (
  <div className='activity-log'>
    <div className='white'>
      <div className='inner_container col-lg-12'>
        <EmployeeNotice
          hash={match.params.hash}
          onDone={() => history.push('/dashboard')}
        />
      </div>
    </div>
  </div>
);

export default NoticePage;
